/* global PRODUCTION*/

/* @ngInject */
export default class {
  constructor(
    angularAuth0,
    $cookies,
    $q,
    $log,
    $window,
    authManager,
    $location,
    store,
    ApiClass,
    JwtClass,
    HelperClass,
    MsTeamsClass
  ) {
    this.angularAuth0 = angularAuth0;
    this.ApiClass = ApiClass;
    this.JwtClass = JwtClass;
    this.HelperClass = HelperClass;
    this.authManager = authManager;
    this.MsTeamsClass = MsTeamsClass;
    this.$cookies = $cookies;
    this.$location = $location;
    this.$log = $log;
    this.$q = $q;
    this.store = store;
    this.$window = $window;
    this.LoginUrlPromise = undefined;
    this._authPopup = undefined;
    this._authInterval = undefined;
    if (!this.MsTeamsClass.inTeams()) {
      this.getAuthenticationUrlPromise = this.getAuthenticationUrl();
    }
  }

  getAuthenticationUrl() {
    // Return existing promise
    if (this.LoginUrlPromise && !this.LoginUrlPromise.status) {
      return this.LoginUrlPromise;
    }

    // Create new promise
    this.LoginUrlPromise = this.$q((resolve, reject) => {
      const id = this.HelperClass.getSubDomain();

      return this.ApiClass.authIdTypeGet({
        id,
        type: 'login_url'
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          this.$log.warn('AuthClass.redirectToAuthenticationUrl');
          this.$log.error(error);
          reject(error);
        });
    });

    return this.LoginUrlPromise;
  }

  redirectToAuthenticationUrl(redirect) {
    return this.getAuthenticationUrlPromise
      .then(({ login_url, login_required }) => {
        if (login_url && (redirect || (login_required && !redirect))) {
          window.location.href = login_url;
          return this.$q.resolve('login url found');
        }

        return this.$q.resolve('no login url');
      })
      .catch(error => {
        this.$log.warn('AuthClass.redirectToAuthenticationUrl');
        this.$log.error(error);
        throw error;
      });
  }

  authenticateAuth0() {
    return this.$q(resolve => {
      const hash = window.location.hash;

      if (!hash.includes('access_token')) {
        return resolve('No Hash');
      }

      this.angularAuth0.parseHash({ hash }, (error, authResult) => {
        if (error) {
          resolve('No Hash');
          this.$log.error(error);
          throw error;
        }

        if (!authResult) {
          return resolve('No Auth');
        }

        this.JwtClass.setAuth0Session(authResult);
        resolve('Hash');
      });
    });
  }

  authenticateCognito() {
    return this.$q(resolve => {
      const { id_token, access_token, refresh_token, expires_in, token_type } = this.$location.$$search;

      const access_token_cookie = this.$cookies.get('__prolaera_access_token');
      const refresh_token_cookie = this.$cookies.get('__prolaera_refresh_token');

      if (!id_token) return resolve('No Auth');

      this.JwtClass.setCognitoSession({
        id_token,
        access_token: access_token || access_token_cookie,
        refresh_token: refresh_token || refresh_token_cookie,
        expires_in,
        token_type
      });

      resolve('Hash');
    });
  }

  authenticateMsTeamsSso($stateParams) {
    return this.$q(resolve => {
      const { access_token, refresh_token, expires_in } = $stateParams || this.$location.$$search;

      const access_token_cookie = this.$cookies.get('__prolaera_access_token');
      const refresh_token_cookie = this.$cookies.get('__prolaera_refresh_token');

      this.JwtClass.setMsTeamsSsoSession({
        access_token: access_token || access_token_cookie,
        refresh_token: refresh_token || refresh_token_cookie,
        expires_in: expires_in
      });

      resolve('Hash');
    });
  }

  authenticationPopup(options = {}) {
    const { company_id = 1, height = 750, width = 500 } = options;

    const top = this.$window.outerHeight / 2 + this.$window.screenY - height / 2;
    const left = this.$window.outerWidth / 2 + this.$window.screenX - width / 2;

    options.path = options.path || `/?company_id=${company_id}`; // Login URL
    options.windowName = options.windowName || 'Sign-In/Sign-Up'; // should not include space for IE
    options.windowOptions =
      options.windowOptions ||
      `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=${width},height=${height},top=${top},left=${left}`;
    options.callback =
      options.callback ||
      function() {
        window.location.reload(); // Use JS window to reload page.
      };

    this._authPopup = this.$window.open(options.path, options.windowName, options.windowOptions);
    this._authInterval = this.$window.setInterval(() => {
      try {
        if (!this._authPopup || !this._authPopup.closed) return;

        this.$window.clearInterval(this._authInterval);
        options.callback();
      } catch (error) {
        this.$log.debug(error);
      }
    }, 1000);
  }

  changePassword(email, callback) {
    this.angularAuth0.changePassword(
      {
        connection: 'Username-Password-Authentication',
        email: email
      },
      callback
    );
  }

  login(email, password, callback) {
    this.angularAuth0.login(
      {
        connection: 'Username-Password-Authentication',
        responseType: 'token',
        scope: 'openid email user_id offline_access user_metadata',
        email: email,
        password: password
      },
      callback
    );
  }

  signup(email, password, company_id = 1, callback) {
    this.angularAuth0.signup(
      {
        connection: 'Username-Password-Authentication',
        responseType: 'token',
        scope: 'openid email offline_access',
        email: email,
        password: password,
        user_metadata: {
          company_id: `${company_id}` // has to be string;
        }
      },
      callback
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/AuthClass.js